import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";
import { useBase } from "@/context/BaseContext";

export const useLogos = () =>
  useQuery({ queryKey: ["panel-logos"], queryFn: async () => (await panelApi.get("/panel/logos")).data });

// Prioridade: logo da base selecionada > logo global > sem logo.
export const useReportLogo = () => {
  const { selectedBaseId } = useBase();
  const d = useLogos().data;
  return (selectedBaseId && d?.bases?.[selectedBaseId]) || d?.global || null;
};

// Desenha a logo no canto superior direito da página atual, mantendo a proporção.
export const addPdfLogo = (doc, logo, { maxW = 110, maxH = 34, top = 14, right = 40 } = {}) => {
  if (!logo?.data) return;
  const s = Math.min(maxW / logo.w, maxH / logo.h);
  const w = logo.w * s;
  const h = logo.h * s;
  try {
    doc.addImage(logo.data, logo.data.startsWith("data:image/png") ? "PNG" : "JPEG", doc.internal.pageSize.getWidth() - right - w, top, w, h);
  } catch (e) { /* imagem inválida: segue sem logo */ }
};
